<template>
    <div class="flex">

        <div class="col-8">

            <!-- Modal -->
            <div id="templateNameModal" class="modal fade" role="dialog">
                <div class="modal-dialog modal-md">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title text-lg">
                                Template Name
                            </h4>
                            <button type="button" dusk="modal-close-button"
                                    class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                    data-dismiss="modal">close
                            </button>
                        </div>
                        <div class="modal-body">
                            <form @keydown="templateForm.errors.clear($event.target.name)">
                                <div class="mb-2">
                                    <div class="form-group">
                                        <input v-model="templateForm.template_name" class="form-control"
                                               :class="{'border-red': templateForm.errors.has('template_name')}" type="text"
                                               id="template_name">
                                    </div>
                                    <div class="text-red text-xs" v-if="templateForm.errors.has('template_name')">
                                        {{ templateForm.errors.get('template_name') }}
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="modal-footer">
                            <button id="save-as-template" name="save-as-template"
                                    @click.prevent="saveAsTemplate"
                                    class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex items-start my-3">

                <button @click="addSection" class="btn btn-outline-secondary rounded-full flex ml-2 text-sm">
                    <span class="material-icons">add</span>
                    Add Section
                </button>

                <button class="btn btn-outline-primary rounded-full ml-2 text-sm" @click="saveInspection">
                    Save
                </button>
            </div>

            <div v-for="(section, sectionIndex) in tempSection.sections" :key="section.uniqueIdentifier"
                 class="card bg-white shadow">
                <div class="card-body">
                    <div class="flex justify-between items-center mb-4">
                        <div class="form-group col-11">
                            <label :for="section.uniqueIdentifier" class="font-bold tracking-wide">Section Title</label>
                            <input v-model="section.title" type="text" class="form-control"
                                   :id="section.uniqueIdentifier">
                        </div>
                        <span @click="deleteSection(sectionIndex)" class="material-icons text-red col-1 cursor-pointer">delete</span>
                    </div>
                    <draggable v-model="section.items" @change="handleSubitemOrderChange($event, sectionIndex)">
                        <transition-group>
                            <div v-for="(item, itemIndex) in section.items" :key="item.uniqueIdentifier"
                                 class="h-64 cursor-pointer mb-16">
                                <div class="flex">
                                    <span class="material-icons col-1">drag_indicator</span>
                                    <div class="col-4 text-center">
                                        <img width="230" v-if="item.url" :src="item.url">
                                        <file-pond v-else
                                                   :name="item.id ? item.id.toString() : item.uniqueIdentifier"
                                                   ref="pond"
                                                   :server="server"
                                                   :onprocessfile="handleOnProcessFile"
                                                   allowRevert="false"
                                                   class-name="my-pond"
                                                   label-idle="Drop or select an image with aspect ratio 4:3"
                                                   accepted-file-types="image/jpeg, image/png"
                                                   labelFileTypeNotAllowed="Invalid File Type"
                                                   fileValidateTypeLabelExpectedTypes="Only JPEG and PNG File Types Are Allowed."/>
                                    </div>
                                    <div class="col-6 h-48">
                                        <ckeditor-proposal :id="item.uniqueIdentifier" v-model="item.text"></ckeditor-proposal>
                                    </div>
                                    <span @click.prevent="deleteItem(sectionIndex, itemIndex)"
                                          class="material-icons text-red col-1 cursor-pointer">delete</span>
                                </div>
                            </div>
                        </transition-group>
                    </draggable>
                    <div class="flex mt-4">
                        <button @click="addItem(sectionIndex)" class="btn btn-outline-secondary rounded-full flex">
                            <span class="material-icons">add</span>
                            Add Item
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-4 preview pl-0">
            <div class="text-2xl text-grey-darkest bg-primary border-b-2 border-followup-nav px-3 py-2 text-white mb-3">
                Preview
            </div>

            <div class="card bg-white w-full mr-4 shadow">
                <iframe
                    :src="`/proposal/${tempSection.proposal_id}/proposal-inspection-section/${tempSection.id}`"
                    class="reports-frame-style"
                />
            </div>
        </div>
    </div>

</template>

<script>
    import draggable from 'vuedraggable';
    import vueFilePond from 'vue-filepond';
    import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
    import 'filepond/dist/filepond.min.css';
    import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
    import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
    import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
    import FilePondPluginImageTransform from 'filepond-plugin-image-transform';
    import Multiselect from 'vue-multiselect';
    import Form from "../../utils/form";
    import axios from "axios";

    let token = document.head.querySelector('meta[name="csrf-token"]');
    const FilePond = vueFilePond(FilePondPluginImagePreview, FilePondPluginFileValidateType, FilePondPluginImageExifOrientation, FilePondPluginImageTransform);

    export default {
        props: ['section'],
        components: {draggable, FilePond, Multiselect},
        data() {
            return {
                tempSection: {
                    uniqueIdentifier: this.section.uniqueIdentifier,
                    id: this.section.id,
                    proposal_id: this.section.proposal_id,
                    name: this.section.name,
                    include_in_report: this.section.include_in_report,
                    order: this.section.order,
                    tag: this.section.tag,
                    deleteable: this.section.deleteable,
                    sections: Object.values(this.section.sections),
                    signature_section: this.section.signature_section,
                },
                templateForm: new Form({
                    template_name: this.section.template_name,
                    is_template: this.section.is_template,
                }),
                allTemplates: this.section.all_templates,
                selectedTemplate: null,
                editName: false,
                server: {
                    revert: (uniqueFileId, load, error) => {
                        let file = JSON.parse(uniqueFileId).subitem;
                        axios.delete(route('proposal.delete-photo-inpsection-subitem', {
                            proposal: this.tempSection.proposal_id,
                            proposalInspectionSection: this.tempSection.id,
                            token: file.token,
                        }))
                            .catch((err) => error(err.response.message));
                        load();
                    },
                    process: (fieldName, file, metadata, load, error, progress) => {
                        const formData = new FormData();
                        formData.append('file', file, file.name);

                        const request = new XMLHttpRequest();
                        request.open('POST', '/proposal/' + this.tempSection.proposal_id + '/proposal-inspection-subitem/' + fieldName + '/upload-photo');
                        request.setRequestHeader('X-CSRF-TOKEN', token.content);

                        request.upload.onprogress = (e) => {
                            progress(e.lengthComputable, e.loaded, e.total);
                        };
                        request.onload = function () {
                            if (request.status >= 200 && request.status < 300) {
                                load(request.responseText);
                            } else {
                                error('oh no');
                            }
                        };
                        request.send(formData);
                    }
                },
                signature: this.section.signature_section,
            }
        },
        mounted() {
            Bus.$emit('showButton', { button: 'template', value: this.templateForm.is_template });

            Bus.$on('openSaveAsTemplateModal', data => {
                this.openSaveAsTemplateModal();
            });

            Bus.$on('removeAsTemplate', data => {
                this.removeAsTemplate();
            });

            Bus.$on('signature', data => {
                this.tempSection.signature_section = data;
                this.signature = this.tempSection.signature_section;
            });

            Bus.$emit('signature', this.section.signature_section);

            Bus.$emit('allTemplates', this.allTemplates);

            Bus.$on('applyTemplate', data => {
                this.selectedTemplate = data;
                this.applyTemplate();
            });
        },
        methods: {
            handleSubitemOrderChange(event, sectionIndex) {
                if (event.moved) {
                    let oldIndex = event.moved.oldIndex;
                    let newIndex = event.moved.newIndex;
                    this.tempSection.sections[sectionIndex].items[newIndex].order = newIndex;
                    if (newIndex < oldIndex) {
                        for (let i = newIndex + 1; i <= oldIndex; i++) {
                            this.tempSection.sections[sectionIndex].items[i].order++;
                        }
                    } else {
                        for (let i = oldIndex; i < newIndex; i++) {
                            this.tempSection.sections[sectionIndex].items[i].order--;
                        }
                    }
                }
            },
            addItem(sectionIndex) {
                let item = {
                    uniqueIdentifier: 'subitem-' + Math.random().toString(36).substring(2),
                    text: null,
                    url: null,
                    path: null,
                    token: null,
                    order: this.tempSection.sections[sectionIndex].items.length,
                };
                this.tempSection.sections[sectionIndex].items.push(item);
                this.saveInspection();
            },
            addSection() {
                let section = {
                    uniqueIdentifier: 'subsection-' + Math.random().toString(36).substring(2),
                    title: null,
                    order: this.tempSection.sections.length,
                    items: [
                        {
                            uniqueIdentifier: 'subitem-' + Math.random().toString(36).substring(2),
                            text: null,
                            url: null,
                            path: null,
                            token: null,
                            order: 0,
                        }
                    ],
                };
                this.tempSection.sections.push(section);
                this.saveInspection();
            },
            deleteSection(sectionIndex) {
                this.tempSection.sections.splice(sectionIndex, 1);
            },
            deleteItem(sectionIndex, itemIndex) {
                this.tempSection.sections[sectionIndex].items.splice(itemIndex, 1);
            },
            saveInspection() {
                this.$emit('inspectionChanged', this.tempSection);
            },
            handleOnProcessFile(error, resourceFile) {
                let subitem = JSON.parse(resourceFile.serverId).subitem;
                this.tempSection.sections[subitem.inspection_subsection_order].items[subitem.order] = subitem;
                this.saveInspection();
            },
            openSaveAsTemplateModal() {
                $('#templateNameModal').modal('show');
            },
            saveAsTemplate() {
                this.templateForm.is_template = 1;
                this.templateForm.put('/proposal-generator/inspection/' + this.tempSection.id + '/template')
                    .then((data) => {
                        if (data.status === 'success') {
                            $("#templateNameModal").modal("hide");
                            this.allTemplates = data.templates;
                            Bus.$emit('allTemplates', this.allTemplates);
                        }
                    });
                Bus.$emit('showButton', { button: 'template', value: this.templateForm.is_template });
            },
            removeAsTemplate() {
                this.templateForm.is_template = 0;
                this.templateForm.put('/proposal-generator/inspection/' + this.tempSection.id + '/template')
                    .then((data) => {
                        if (data.status === 'success') {
                            this.allTemplates = data.templates;
                            Bus.$emit('allTemplates', this.allTemplates);
                        }
                    });
                Bus.$emit('showButton', { button: 'template', value: this.templateForm.is_template });
            },
            applyTemplate(){
                if (this.selectedTemplate) {
                    this.tempSection.uniqueIdentifier   = this.selectedTemplate.uniqueIdentifier;
                    this.tempSection.name               = this.selectedTemplate.name;
                    this.tempSection.include_in_report  = this.selectedTemplate.include_in_report;
                    this.tempSection.order              = this.selectedTemplate.order;
                    this.tempSection.tag                = this.selectedTemplate.tag;
                    this.tempSection.deleteable         = this.selectedTemplate.deleteable;
                    this.tempSection.sections           = Object.values(this.selectedTemplate.sections.map((s)=> {
                        delete s.id;
                        s.items.map((i) => {
                            delete i.id;
                            delete i.inspection_subsection_id;
                            delete i.inspection_subsection_order;
                        });
                        return s;
                    }));
                }
            },
            signatureFooter() {
                this.tempSection.signature_section = !this.signature;
                this.signature = this.tempSection.signature_section;
            },
        }
    }
</script>

<style scoped>
    .filepond--root {
        height: 292px !important;
    }

    .filepond--drop-label {
        height: 292px !important;
    }

    .filepond--panel-root {
        background-color: transparent;
        border: 2px dashed #dae1e7;
    }
    .reports-frame-style {
        height: 75vh;
        width: 100%;
        border: 1px solid grey;
        border-radius: 7px;
    }
    .resource-images-div {
        float: left;
        padding: 0 5px;
        margin-bottom: 10px;
        height: 100px;
    }
    span.resource-images-name {
        font-size: 10px;
        word-break: break-word;
    }
    .resource-images {
        height: 55px;
    }
    .tool-buttons {
        border: 1px solid #01b1af;
        margin: 0 5px;
        font-size: 12px;
        padding: 10px 0;
        color: #01b1af;
        text-align: center;
        margin-bottom: 9px;
        max-width: 45% !important;
        margin-right: 5px;
        margin-left: 7px;
    }
    .tool-buttons:hover {
        background-color: #01b1af1c;
        cursor: pointer;
    }
</style>

